import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { LOConfiguration } from 'src/types/configurations';

export interface SaveLOConfigurationParams {
  configuration: LOConfiguration['configuration'];
}

export interface SaveLOConfigurationResponse {
  success: boolean;
  configurationId?: string;
  message?: string;
}

const saveLOConfiguration: MutationFunction<
  SaveLOConfigurationResponse,
  SaveLOConfigurationParams
> = async ({ configuration }) => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SaveLOConfigurationResponse>(
    '/configurations/LoanIngestionFields',
    {
      method: 'POST',
      body: { configuration },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to save LO configuration');
};

export default saveLOConfiguration;
